import client from './client';

export interface CreditBatch {
    credit_id: string;
    pdfs_remaining: number;
    expires_at_utc: string;
}

export interface PrepaidBalanceResponse {
    total_credits: number;
    batches: CreditBatch[];
}

export const billingApi = {
    /**
     * Get the current valid prepaid credit balance
     */
    getPrepaidBalance: async (): Promise<PrepaidBalanceResponse> => {
        const response = await client.get('/api/v1/billing/balance');
        return response.data;
    },

    /**
     * Get credit usage preference
     */
    getUsagePreference: async (): Promise<{ preference: string }> => {
        const response = await client.get('/api/v1/billing/preference');
        return response.data;
    },

    /**
     * Update credit usage preference
     */
    updateUsagePreference: async (preference: string): Promise<{ message: string }> => {
        const response = await client.put('/api/v1/billing/preference', { preference });
        return response.data;
    },

    /**
     * Get daily usage history for the last N days
     */
    getUsageHistory: async (days: number = 30): Promise<any[]> => {
        const response = await client.get('/api/v1/billing/usage-history', {
            params: { days }
        });
        return response.data;
    },

    /**
     * Create a Stripe Checkout Session for bulk credit purchase
     */
    createBulkCheckout: async (
        successUrl: string,
        cancelUrl: string
    ): Promise<{ checkout_url: string }> => {
        const response = await client.post('/api/v1/billing/bulk-checkout', {
            success_url: successUrl,
            cancel_url: cancelUrl
        });
        return response.data;
    },

    /**
     * Get session-level usage history with optional filters
     */
    getSessionHistory: async (filters?: {
        start_date?: string;
        end_date?: string;
        practice_id?: string;
        staff_id?: string;
    }): Promise<any[]> => {
        const response = await client.get('/api/v1/billing/session-history', {
            params: filters
        });
        return response.data;
    },

    /**
     * Create a Stripe Billing Portal Session for managing subscriptions
     */
    createPortalSession: async (items: { return_url: string }): Promise<{ url: string }> => {
        const response = await client.post('/api/v1/billing/portal-session', items);
        return response.data;
    },
};
